import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { KeyNameModel } from 'src/app/models/key-value-model';
import { BusinessHour } from 'src/app/models/register-business';

@Component({
  selector: 'app-business-hour-modal',
  templateUrl: './business-hour-modal.component.html',
  styleUrls: ['./business-hour-modal.component.scss']
})
export class BusinessHourModalComponent {
  @ViewChild('businessHourModal') businessHourTemplate!: TemplateRef<BusinessHourModalComponent>;
  hour = new BusinessHour();
  @Input()
  set hourList(value: BusinessHour[]) {
    this._hourList = value;
    this.setHour();
  }
  get hourList(): BusinessHour[] {
    return this._hourList;
  }
  @Input()
  set DayOfWeek(value: KeyNameModel[]) {
    this._dayOfWeek = value;
    this.init();
  }
  get DayOfWeek(): KeyNameModel[] {
    return this._dayOfWeek;
  }
  _dayOfWeek: KeyNameModel[];
  _hourList: BusinessHour[] = [];
  @Output()
  businessHourAdded =  new EventEmitter<BusinessHour[]>();

  init(): void {
    if(this._hourList.length == 0 && this._dayOfWeek) {
      this._dayOfWeek.forEach(day => {
        this.hourList.push({
          id:0,
          Day: day.name,
          From:"",
          To:"",
          isOpen:true
        })
      })
    }
  }
  setHour(){
    let orderedHourList = [];
    if(this._dayOfWeek.length>0 && this._hourList.length> 0)
      {
        this._dayOfWeek.forEach(day => {
          let hour = this._hourList.find(x=>x.Day === day.name);
          if( hour == null){
          orderedHourList.push({
            id:0,
            Day: day.name,
            From:"",
            To:"",
            isOpen:true
          }
        )
      }
        else {
          orderedHourList.push({
            id:hour.id,
            Day: hour.Day,
            From: hour.From,
            To: hour.To,
            isOpen:true
          });
        }
        });

        this._hourList = orderedHourList;
      }
  }

  bussinessHourAdded(){
    this.businessHourAdded.emit(this.hourList);
  }
}
